import React, { useEffect, useState } from "react";

interface IcomSwitchBtn extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  currentValue: boolean;
  handleValue: (value: boolean) => void;
}

export default function IcomSwitchBtn({
  handleValue,
  currentValue = false,
  ...props
}: IcomSwitchBtn) {
  const [isOn, setIsOn] = useState(currentValue);

  const toggleSwitch = () => {
    handleValue(!isOn);
    // setIsOn(!isOn);
  };

  useEffect(() => {
    setIsOn(currentValue);
  }, [currentValue]);

  return (
    <div className="flex items-center">
      <button
        onClick={toggleSwitch}
        className={`w-12 h-6 flex items-center rounded-full p-1 duration-300 ease-in-out ${
          isOn
            ? "bg-primary-blue-500 dark:bg-primary-blue-400"
            : "bg-gray-300 dark:bg-neutral-gray-800"
        }`}
        {...props}
      >
        <div
          className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-300 ease-in-out ${
            isOn ? "translate-x-6" : ""
          }`}
        ></div>
      </button>
    </div>
  );
}
